import { breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Container = styled.div`
  width: 100%;
  @media (min-width: ${breakpoints.lg}) {
    padding-bottom: 2rem;
  }
`;

export const LeftIconWrapper = styled.div`
  align-self: flex-start;
  padding-right: 1rem;
  width: 2.25rem;
  line-height: 0;
`;

export const DiscountWrapper = styled.div`
  margin-top: 0.75rem;
`;

export const SkinAnalyzerWrapper = styled.div`
  display: block;

  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`;

export const HairAnalyzerWrapper = styled.div`
  display: block;

  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`;
